import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react'

import { GeneralContext } from 'contexts/General'

import { StyledIndex, } from './styles'

import { HEADER_HEIGHT } from 'config/stitches.config'

import DefaultIndex from './DefaultIndex'
import HistoryIndex from './HistoryIndex'

const Index = () => {
  const [currentIndex, setCurrentIndex] = useState(null)
  const [visible, setIsVisible] = useState(false)
  const [theme, setTheme] = useState('default')

  const { page: { index } = {} } = useContext(GeneralContext)
  const { indexType } = index

  const footer = useRef(null)
  const firstSection = useRef(null)

  useEffect(() => {
    let ScrollTrigger
    footer.current = document.querySelector('footer')
    let lastSection = footer.current
    firstSection.current = document.querySelector('[data-section-index]')

    // il footer potrebbe non esserci
    if (!footer.current) {
      const sections = Array.from(document.querySelectorAll('[data-section-index]'))
      lastSection = sections[sections.length - 1]
    }
    const initTriggers = async () => {
      ScrollTrigger = (await import('gsap/dist/ScrollTrigger')).ScrollTrigger

      ScrollTrigger.create({
        trigger: firstSection.current,
        start: 'top center',
        endTrigger: lastSection,
        end: 'top 80%',
        // markers: {
        //   startColor: 'pink', endColor: 'purple', fontSize: '18px', fontWeight: 'bold', indent: 20
        // },
        onToggle: self => setIsVisible(self.isActive)
      })

      if (index.items) {
        index.items.map((item, idx) => {
          const element = document.querySelector(`[data-section-index="${item.target}"]`)
          if (!element) return

          ScrollTrigger.create({
            trigger: element,
            start: 'top center',
            end: 'bottom center',
            onEnterBack: self => {
              if (!self.isActive) return
              setCurrentIndex(idx)
              setTheme(element.dataset.theme)
            },
            onEnter: self => {
              if (!self.isActive) return
              setCurrentIndex(idx)
              setTheme(element.dataset.theme)
            }
          })
        })
      }
    }

    initTriggers()

    return () => {
      setIsVisible(false)
      if (ScrollTrigger) {
        const triggers = ScrollTrigger.getAll()
        triggers.forEach((trigger) => trigger.kill())
      }
    }
  }, [index])

  if (!index.items) return <></>


  const onIndexButtonClick = (sectionTarget, idx) => {
    const scrollTo = document.querySelector(`[data-section-index="${sectionTarget}"]`)
    if (!scrollTo) return

    setCurrentIndex(idx)

    window.scrollTo({
      top: scrollTo.offsetTop - HEADER_HEIGHT.desktop,
      behavior: 'smooth'
    })
  }


  return (
    <StyledIndex
      isVisible={visible}
    >
      {
        (!indexType || indexType !== 'history') &&
        <DefaultIndex
          items={index.items}
          currentIndex={currentIndex}
          onIndexButtonClick={onIndexButtonClick}
          theme={theme}
        />
      }

      {
        !!indexType &&
        indexType === 'history' &&
        <HistoryIndex
          {...index}
          currentIndex={currentIndex}
          onIndexButtonClick={onIndexButtonClick}
          theme={theme}
        />
      }

    </StyledIndex>
  )
}

export default Index
